// isEdge
export default (function() {
  return navigator.userAgent.toLowerCase().indexOf('edge') !== -1;
})();
